import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';
import {
  AppInsightsContext,
  GeneralImage,
  MetadataContext,
  TrackEventKey,
  TrackEventName,
  TrackEventType,
  UserContext,
} from '@/components';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { downloadImage } from '@/api';

interface ImagePreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const ImagePreview = ({ content, onClose }: ImagePreviewProps) => {
  const appInsights = useContext(AppInsightsContext);
  const { pageId } = useContext(MetadataContext);
  const router = useRouter();
  const user = useContext(UserContext);

  const imageModel = {
    imageUrl: content?.isBlob ? content.blobUri || '' : content?.content?.imageUrl || '',
    imageAlt: content?.content?.imageCaption || 'Preview image',
    caption: content?.content?.imageCaption || '',
    copyrightText: content?.content?.imageCopyright || '',
    mediaId: content?.content?.imageId || 0,
  };

  const handleDownload = async () => {
    downloadImage(imageModel);

    appInsights.trackCustomEvent(TrackEventName.PAGE, TrackEventKey.IMAGE, TrackEventType.DOWNLOAD, user, {
      pageId,
      pagePath: router.asPath,
      imageID: content?.content?.imageId,
    });
  };

  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="Image"
      subTitle={content?.content?.imageCaption}
      onDownload={handleDownload}
      className="h-full"
    >
      <div className="flex h-full flex-col items-center justify-center">
        <div className="flex h-full flex-col">
          <div className="h-full overflow-hidden">
            <GeneralImage
              image={imageModel}
              widths={{ lg: 1024, xl: 1428 }}
              //setContanerSize
              showCopyrightText
              disableClick
              dataNotLazy
              className="[&_.buttons]:hidden"
            />
          </div>
        </div>
      </div>
    </ContentPreviewWraper>
  );
};

export default ImagePreview;
